export const yearsOldCounter = (birthday) => {
    const nowDate = Date.now();
    const birthdayDate = new Date(birthday);
    const days = (nowDate - birthdayDate) / (60 * 60 * 24 * 1000);
    return `${Math.floor(days / 365)}`;
};
